"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var ControllerAutocomplete_1 = require("./ControllerAutocomplete");
var response_1 = require("../../utils/response");
var defaultOptions = {
    maxResultsForAddCities: 5,
    minStringLengthForSearch: 1
};
var AutocompleteHelper = /** @class */ (function () {
    function AutocompleteHelper(controller, options) {
        this._prevAddresses = [];
        this._currentAddressString = '';
        this._controller = controller;
        this._options = Object.assign({}, defaultOptions, options);
    }
    AutocompleteHelper.prototype.SetCenter = function (lat, lon) {
        this._lat = lat;
        this._lon = lon;
    };
    AutocompleteHelper.prototype.SetRadius = function (radius) {
        this._radius = radius;
    };
    AutocompleteHelper.prototype.GetFilter = function (addGeoAndRadius) {
        var result = {
            patern: ''
        };
        if (addGeoAndRadius) {
            result.lat = this._lat;
            result.lon = this._lon;
            result.radius = this._radius;
        }
        return result;
    };
    AutocompleteHelper.prototype.GetSuggestions = function () {
        return this._prevAddresses;
    };
    AutocompleteHelper.prototype.GetCurrentAddressString = function () {
        return this._currentAddressString;
    };
    AutocompleteHelper.prototype.GetSelectedCityName = function () {
        if (this._selectedCity !== undefined) {
            return this._selectedCity.v;
        }
        if (this._selectedStreet !== undefined) {
            return this._selectedStreet.c;
        }
        if (this._selectedHouse !== undefined) {
            return this._selectedHouse.c;
        }
        if (this._selectedObject !== undefined) {
            return this._selectedObject.c;
        }
    };
    AutocompleteHelper.prototype.ChangeInputValue = function (newTextValue) {
        return __awaiter(this, void 0, void 0, function () {
            var isBackspaceDelLastChar, response, selectedCityName, trimmedTextValue, filter, filter, filter, customRequest, customResponse_1, hasSelectedItem, filter, citiesResponse, customResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isBackspaceDelLastChar = detectBackspaceDelLastChar(this._currentAddressString, newTextValue);
                        this._checkBackspaceOrPasteChanges(newTextValue);
                        this._currentAddressString = newTextValue;
                        // если распознан BACKSPACE, то не нужно делать запрос, пока юзер не введет новую букву            
                        if (isBackspaceDelLastChar || newTextValue.length < this._options.minStringLengthForSearch) {
                            return [2 /*return*/, response_1.getSuccessResponse([])];
                        }
                        selectedCityName = this.GetSelectedCityName();
                        trimmedTextValue = newTextValue;
                        if (!(selectedCityName !== undefined)) return [3 /*break*/, 6];
                        trimmedTextValue = cutAddressPart(newTextValue, selectedCityName);
                        if (!(this._selectedStreet !== undefined)) return [3 /*break*/, 2];
                        trimmedTextValue = cutAddressPart(trimmedTextValue, this._selectedStreet.v);
                        filter = __assign(__assign({}, this.GetFilter(false)), { city: selectedCityName, street: this._selectedStreet.v, patern: trimmedTextValue });
                        return [4 /*yield*/, this._controller.GetHouses(filter)];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 5];
                    case 2:
                        if (!(trimmedTextValue.length > 0)) return [3 /*break*/, 4];
                        filter = __assign(__assign({}, this.GetFilter(false)), { city: selectedCityName, patern: trimmedTextValue });
                        return [4 /*yield*/, this._controller.GetAddresses(filter)];
                    case 3:
                        response = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        response = response_1.getSuccessResponse([]);
                        _a.label = 5;
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        filter = __assign(__assign({}, this.GetFilter(true)), { patern: newTextValue });
                        return [4 /*yield*/, this._controller.GetAddresses(filter)];
                    case 7:
                        response = _a.sent();
                        _a.label = 8;
                    case 8:
                        if (!(response.Success && response.Result !== undefined)) return [3 /*break*/, 13];
                        customRequest = void 0;
                        if (!(response.Result.length === 0)) return [3 /*break*/, 10];
                        customRequest = this.getStreetAndHouseRequest(newTextValue);
                        if (!(customRequest !== undefined)) return [3 /*break*/, 10];
                        return [4 /*yield*/, customRequest];
                    case 9:
                        customResponse_1 = _a.sent();
                        response = mergeResponses(response, customResponse_1);
                        _a.label = 10;
                    case 10:
                        hasSelectedItem = this._selectedCity !== undefined
                            || this._selectedObject !== undefined
                            || this._selectedStreet !== undefined
                            || this._selectedHouse !== undefined;
                        if (!(hasSelectedItem === false && customRequest === undefined && trimmedTextValue.length > 0)) return [3 /*break*/, 12];
                        if (!(response.Result.length < this._options.maxResultsForAddCities)) return [3 /*break*/, 12];
                        filter = __assign(__assign({}, this.GetFilter(false)), { patern: trimmedTextValue });
                        return [4 /*yield*/, this._controller.GetCities(filter)];
                    case 11:
                        citiesResponse = _a.sent();
                        response = mergeResponses(response, citiesResponse);
                        _a.label = 12;
                    case 12:
                        if (response.Result.length > 0) {
                            this._prevAddresses = response.Result;
                        }
                        _a.label = 13;
                    case 13:
                        customResponse = response;
                        customResponse.Result = customResponse.Result.items || customResponse.Result;
                        return [2 /*return*/, customResponse];
                }
            });
        });
    };
    AutocompleteHelper.prototype.getStreetAndHouseRequest = function (address) {
        var streetAndHouseRegex = /(.*?),?\s*(\d+.*)+$/gi;
        //$1 - улица, $2 - номер дома
        if (streetAndHouseRegex.test(address) === false) {
            return;
        }
        var streetName = address.replace(streetAndHouseRegex, '$1').trim();
        var houseNumber = address.replace(streetAndHouseRegex, '$2').trim();
        var streetFromPrevRequests = this._prevAddresses
            .find(function (a) { return (a.t === types_1.AutocompleteAddressType.Street || a.t === types_1.AutocompleteAddressType.House)
            && a.v.toLowerCase().startsWith(streetName.toLowerCase()); });
        var filter = __assign(__assign({}, this.GetFilter(false)), { city: streetFromPrevRequests !== undefined ? streetFromPrevRequests.c : '', 
            //city: '*',
            street: streetName + '*', patern: houseNumber });
        return this._controller.GetHouses(filter);
    };
    AutocompleteHelper.prototype.SelectItem = function (item) {
        if (item.t === types_1.AutocompleteAddressType.City) {
            this._selectedCity = item;
            this._currentAddressString = item.v + ', ';
        }
        else if (item.t === types_1.AutocompleteAddressType.Street) {
            this._selectedStreet = item;
            this._currentAddressString = item.c + ', ' + item.v + ', ';
        }
        else if (item.t === types_1.AutocompleteAddressType.House) {
            this._selectedHouse = item;
            this._currentAddressString = item.c + ', ' + item.v;
        }
        else if (item.t === types_1.AutocompleteAddressType.Object) {
            this._selectedObject = item;
            this._currentAddressString = item.c + ', ' + item.v;
        }
        if (this._selectedCity === undefined) {
            // если вводил без города и выбрал дом/объект, то знание города пригодится потом
            this._selectedCity = {
                v: item.c,
                c: '',
                g: Object.assign({}, item.g),
                n: -1,
                t: types_1.AutocompleteAddressType.City
            };
        }
        //this._selectedItem = item;
    };
    AutocompleteHelper.prototype.Clear = function () {
        //this._selectedItem = undefined;
        this._selectedCity = undefined;
        this._selectedStreet = undefined;
        this._selectedHouse = undefined;
        this._selectedObject = undefined;
        this._currentAddressString = '';
        this._prevAddresses = [];
    };
    AutocompleteHelper.prototype._checkBackspaceOrPasteChanges = function (newTextValue) {
        if (newTextValue === '') {
            this.Clear();
            return;
        }
        var newTextValueLowerCase = newTextValue.toLowerCase();
        if (this._selectedHouse !== undefined
            && newTextValueLowerCase.includes(this._selectedHouse.v.toLowerCase()) === false) {
            this._selectedHouse = undefined;
        }
        if (this._selectedStreet !== undefined
            && newTextValueLowerCase.includes(this._selectedStreet.v.toLowerCase()) === false) {
            this._selectedStreet = undefined;
        }
        if (this._selectedObject !== undefined
            && newTextValueLowerCase.includes(this._selectedObject.v.toLowerCase()) === false) {
            this._selectedObject = undefined;
        }
        if (this._selectedCity !== undefined
            && newTextValueLowerCase.includes(this._selectedCity.v.toLowerCase()) === false) {
            this._selectedCity = undefined;
        }
    };
    return AutocompleteHelper;
}());
exports.AutocompleteHelper = AutocompleteHelper;
function cutAddressPart(address, part) {
    var partExpression = part
        .replace('(', '\\(')
        .replace(')', '\\)');
    return address.replace(new RegExp(partExpression + "[,\\s]*"), '');
}
var mergeResponses = function (response1, response2) {
    if (response1.Success === false || response1.Result === undefined
        || response2.Success === false || response2.Result === undefined) {
        return response1;
    }
    // immutable
    var newResponse = Object.assign({}, response1);
    newResponse.Result = newResponse.Result
        .concat(response2.Result)
        .reduce(function (prevSuggestions, currentSuggestion) {
        var isUnique = !prevSuggestions.some(function (s) { return ControllerAutocomplete_1.autocompleteAddressComparer(s, currentSuggestion); });
        if (isUnique) {
            prevSuggestions.push(currentSuggestion);
        }
        return prevSuggestions;
    }, []);
    return newResponse;
};
var detectBackspaceDelLastChar = function (prevValue, currentValue) {
    return currentValue.length < prevValue.length && prevValue.startsWith(currentValue);
};
//# sourceMappingURL=AutocompleteHelper.js.map